import { render, staticRenderFns } from "./PaymentsAndCurrenciesNetworks.vue?vue&type=template&id=1745936e&"
import script from "./PaymentsAndCurrenciesNetworks.vue?vue&type=script&lang=js&"
export * from "./PaymentsAndCurrenciesNetworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports